import type React from 'react';
import type { IconProps } from 'types/icon';

const ClipboardHeart: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M21.3333 5.33334C24.2334 5.34949 25.8039 5.47809 26.8284 6.5026C28 7.67417 28 9.55979 28 13.331V21.331C28 25.1023 28 26.9879 26.8284 28.1595C25.6569 29.331 23.7712 29.331 20 29.331H12C8.22876 29.331 6.34315 29.331 5.17157 28.1595C4 26.9879 4 25.1023 4 21.331V13.331C4 9.55979 4 7.67417 5.17157 6.5026C6.19608 5.47809 7.76663 5.34949 10.6667 5.33334"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M16 15.5885L15.4813 16.1302C15.7713 16.4079 16.2287 16.4079 16.5187 16.1302L16 15.5885ZM16 21.1642L16 20.4142L16 21.1642ZM15.0359 20.7107L15.4652 20.0958C14.8931 19.6964 14.1838 19.145 13.6256 18.5392C13.0405 17.9044 12.75 17.3477 12.75 16.929H12H11.25C11.25 17.9436 11.8856 18.8646 12.5226 19.5558C13.1863 20.276 13.9951 20.8988 14.6066 21.3257L15.0359 20.7107ZM12 16.929H12.75C12.75 16.074 13.1501 15.6319 13.5731 15.4836C14.0172 15.3279 14.7308 15.4115 15.4813 16.1302L16 15.5885L16.5187 15.0467C15.4693 14.042 14.1829 13.6803 13.0769 14.068C11.95 14.4631 11.25 15.5529 11.25 16.929H12ZM16.9641 20.7108L17.3934 21.3257C18.0049 20.8988 18.8137 20.276 19.4774 19.5558C20.1144 18.8646 20.75 17.9436 20.75 16.9289H20H19.25C19.25 17.3477 18.9594 17.9045 18.3744 18.5392C17.8162 19.145 17.1069 19.6964 16.5348 20.0958L16.9641 20.7108ZM20 16.9289H20.75C20.75 15.5529 20.05 14.4631 18.9231 14.068C17.8171 13.6803 16.5307 14.042 15.4813 15.0467L16 15.5885L16.5187 16.1302C17.2692 15.4115 17.9828 15.3279 18.4269 15.4836C18.8499 15.6319 19.25 16.074 19.25 16.9289H20ZM15.0359 20.7107L14.6066 21.3257C14.9826 21.5882 15.4033 21.9142 16 21.9142L16 21.1642L16 20.4142C15.9836 20.4142 15.9675 20.4157 15.9043 20.3833C15.8125 20.3363 15.6973 20.2578 15.4652 20.0958L15.0359 20.7107ZM16.9641 20.7108L16.5348 20.0958C16.3027 20.2578 16.1875 20.3363 16.0957 20.3833C16.0325 20.4157 16.0164 20.4142 16 20.4142L16 21.1642L16 21.9142C16.5967 21.9142 17.0174 21.5882 17.3934 21.3257L16.9641 20.7108Z"
        fill={color}
      />
      <path
        d="M10.668 4.66666C10.668 3.56209 11.5634 2.66666 12.668 2.66666H19.3346C20.4392 2.66666 21.3346 3.56209 21.3346 4.66666V5.99999C21.3346 7.10456 20.4392 7.99999 19.3346 7.99999H12.668C11.5634 7.99999 10.668 7.10456 10.668 5.99999V4.66666Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ClipboardHeart;
